// ABOUTME: Global host that overlays a sidepanel when the obfuscated ?sp= deep-link param is present.
// ABOUTME: Reads the current route's query param, resolves the panel, and clears the param on close.

import { useCallback, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { decodeSidepanel } from "./sidepanelCodec";
import { resolveSidepanel } from "./resolveSidepanel";
import { SIDEPANEL_PARAM } from "./sidepanelLink";

// Holds the open state for one resolved deep-link. Keyed by the raw blob so a new link
// remounts with a fresh open state.
const DeepLinkPanel = ({ resolved, onClose }) => {
    const [isExtended, setIsExtended] = useState(true);
    const { Component, props } = resolved;

    const handleSetIsExtended = (value) => {
        const next = typeof value === "function" ? value(isExtended) : value;
        setIsExtended(next);
        if (next === false) {
            // let the drawer animate out, then drop the deep-link param from the url
            setTimeout(onClose, 300);
        }
    };

    return (
        <Component {...props} isExtended={isExtended} setIsExtended={handleSetIsExtended} />
    );
};

const SidepanelDeepLinkHost = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const blob = searchParams.get(SIDEPANEL_PARAM);

    const decoded = useMemo(() => decodeSidepanel(blob), [blob]);
    const resolved = useMemo(() => resolveSidepanel(decoded), [decoded]);

    const clearParam = useCallback(() => {
        setSearchParams((prev) => {
            const p = new URLSearchParams(prev);
            p.delete(SIDEPANEL_PARAM);
            return p;
        }, { replace: true });
    }, [setSearchParams]);

    if (!resolved) return null;

    return <DeepLinkPanel key={blob} resolved={resolved} onClose={clearParam} />;
};

export default SidepanelDeepLinkHost;
